
import {
  DELETE_ACTIVITY_ADD_ONS,
  DELETE_ACTIVITY_MANDATORY_FEES,
  DELETE_RELATED_ACCOMMODATIONS,
  DELETE_RELATED_ACTIVITIES,
  DELETE_INTEGRATIONS,
  CLEAR_DELETED_FIELDS
} from 'constants/activityAndAccommodationActionTypes';

const initialState = {
  deletedAddOns: [],
  deletedMandatoryFees: [],
  deletedRelatedAccommodations: [],
  deletedRelatedActivities: [],
  deletedIntegrations: []
};

const activityReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_DELETED_FIELDS: {
      return {
        ...state,
        deletedAddOns: [],
        deletedMandatoryFees: [],
        deletedRelatedAccommodations: [],
        deletedRelatedActivities: [],
        deletedIntegrations: []
      };
    }
    case DELETE_ACTIVITY_ADD_ONS: {
      return {
        ...state,
        deletedAddOns: [
          ...new Set(state.deletedAddOns.concat(parseInt(action.id)))
        ]
      };
    }
    case DELETE_ACTIVITY_MANDATORY_FEES: {
      return {
        ...state,
        deletedMandatoryFees: [
          ...new Set(state.deletedMandatoryFees.concat(parseInt(action.id)))
        ]
      };
    }
    case DELETE_RELATED_ACCOMMODATIONS: {
      return {
        ...state,
        deletedRelatedAccommodations: [
          ...new Set(
            state.deletedRelatedAccommodations.concat(parseInt(action.id))
          )
        ]
      };
    }
    case DELETE_RELATED_ACTIVITIES: {
      return {
        ...state,
        deletedRelatedActivities: [
          ...new Set(state.deletedRelatedActivities.concat(parseInt(action.id)))
        ]
      };
    }
    case DELETE_INTEGRATIONS: {
      return {
        ...state,
        deletedIntegrations: [
          ...new Set(state.deletedIntegrations.concat(parseInt(action.id)))
        ]
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export default activityReducer;
